<template>
  <component
    ref="componentRef"
    :is="componentsName"
    @updateTable="updateTable"
  >
  </component>
</template>

<script>
import { defineComponent, ref, watch, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import salePerson from '@/views/mobileMenu/components/modal/salePerson.vue';
import authority from '@/views/mobileMenu/components/modal/authority.vue';

export default defineComponent({
    components: { salePerson, authority },
    setup() {
        const route = useRoute();
        const router = useRouter();

        const componentsName = ref();

        const componentRef = ref();
        
        const editSale = (data) => {
            nextTick(() => {
                componentRef.value.setFormData(data);
            });
        };

        // 更新table数据
        const updateTable = (isUpdate) => {
            componentsName.value = '';
            router.back();
        };

        // 权限
        const setAuthority = (data) => {
            nextTick(() => {
                componentRef.value.setSaleAuthority(data);
            });
        };

        const setFormPid = (data) => {
            nextTick(() => {
                componentRef.value.setFormPid(data);
            });
        };
        
        const caseAction = (type, data) => {
            switch (type) {
                case 'editSale':
                    editSale(JSON.parse(data));
                    break;
                case 'addSale':
                    setFormPid(JSON.parse(data));
                    break;
                case 'authority':
                    setAuthority(JSON.parse(data));
                    break;
                default:
                    break;
            }
        };
        // 初始化
        const init = (value) => {
            if (!value) return;
            const { name, type, data } = value;
            componentsName.value = name;
            caseAction(type, data);
        };

        watch(() => route, (val) => {
            init(val.query);
        }, {
            immediate: true,
            deep: true,
        });

        return {
            componentsName,
            componentRef,
            updateTable,
        };
    }
});
</script>

<style lang="less" scoped>

</style>
